import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSortArrowUpDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSortArrowUpDown"><Path d="M3.5 3.5H10.5V10.5H3.5V3.5Z" stroke="currentColor"/><Path d="M3.5 13.5H10.5V20.5H3.5V13.5Z" stroke="currentColor"/><Path d="M14.5 7.5L18 4L21.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 16.5L18 20L14.5 16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSortArrowUpDown;
